import { render, staticRenderFns } from "./LegalCaseEditorWorkflow.vue?vue&type=template&id=7c7deeb2&scoped=true&"
import script from "./LegalCaseEditorWorkflow.vue?vue&type=script&lang=js&"
export * from "./LegalCaseEditorWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./LegalCaseEditorWorkflow.vue?vue&type=style&index=0&id=7c7deeb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7deeb2",
  null
  
)

export default component.exports